import { css } from '@linaria/core';

export const animateLike = css`
  @keyframes like {
    0% {
      transform: scale(0.25);
    }
    100% {
      transform: scale(1);
    }
  }
  animation: like 0.125s ease-in;
`;
